import Marquee from "react-fast-marquee";
import { useContent } from "../context/ContentContext";

export default function GroupRule() {
    const { content } = useContent();
    const r = content.rule;
    return (
        <section data-testid="rule-section" className="py-12 md:py-16 border-y border-meraki-gold/20 bg-black overflow-hidden">
            <Marquee gradient={false} speed={50} className="overflow-hidden">
                {Array.from({ length: 4 }).map((_, i) => (
                    <span
                        key={`marquee-${i}`}
                        className={`font-display text-7xl md:text-9xl uppercase tracking-tight whitespace-nowrap mx-8 ${
                            i % 2 === 0 ? "text-meraki-gold" : "text-outline"
                        }`}
                    >
                        {r.phrase}
                    </span>
                ))}
            </Marquee>
            <div className="mt-8 text-center text-xs uppercase tracking-[0.4em] text-meraki-muted">
                {r.subtitle}
            </div>
        </section>
    );
}
